import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function TestimonialsStrip() {
  return <section className="py-12 bg-neutral-100 border-y border-neutral-200" data-id="element-299" data-mp="3sqbmhm39w97g">
      <div className="max-w-7xl mx-auto px-4" data-id="element-300" data-mp="3ssent29vlorh">
        <div className="text-center mb-7" data-id="element-301" data-mp="3nzbosembxn3w">
          <h2 className="text-neutral-900 font-bold tracking-widest uppercase text-sm" data-id="element-302" data-mp="3nyab02dximih">
            What Fire Service Instructors Are Saying
          </h2>
          <p className="text-xs text-neutral-800/60 mt-2" data-id="element-303" data-mp="nao2zglba7k">
            Sample preview — example reviews, not verified customer feedback.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-304" data-mp="akp6h4m2q92i">
          {testimonials.map((testimonial, index) => <motion.article key={testimonial.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-neutral-200 p-6 rounded-2xl shadow-sm shadow-neutral-900/5 flex flex-col" data-id="element-305" data-mp="2havcemm56fhu" data-mpi={index}>
              <div className="flex gap-1 text-amber-500 mb-4" aria-label="5 out of 5 stars" data-id="element-306" data-mp="lcckafpl0b7e">
                {[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={16} fill="currentColor" aria-hidden="true" data-id="element-307" data-mp="q5ynzidrp4r2" data-mpi={starIndex} />)}
              </div>
              <p className="text-neutral-800 italic mb-6 text-sm leading-relaxed" data-id="element-308" data-mp="101s8bnxqa2je">
                “{testimonial.text}”
              </p>
              <div className="mt-auto pt-4 border-t border-neutral-200" data-id="element-309" data-mp="144esr3s2kl6k">
                <div className="font-bold text-neutral-900 text-sm" data-id="element-310" data-mp="19389r66keubh">{testimonial.name}</div>
                <div className="text-xs text-red-700 font-semibold mt-0.5" data-id="element-311" data-mp="35vrz7x9or14q">{testimonial.role}</div>
                <div className="flex items-center gap-1.5 text-xs text-neutral-800/60 mt-1.5" data-id="element-312" data-mp="3atthifzaewf5">
                  <img src={`https://flagcdn.com/${testimonial.countryCode}.svg`} alt="" aria-hidden="true" className="w-[18px] h-[13px] rounded-[2px] object-cover shrink-0 ring-1 ring-black/5" data-id="element-313" data-mp="hzcqzar58dhe" />
                  {testimonial.country}
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}